module.exports = __webpack_public_path__ + "static/media/homepage_curriculum.3737bf6c.svg";